const constant = {
    REQ_WEIXIN_OPEN_ID_GET: 'weixin.get.openid',
    REQ_MEMBER_INFO_GET: 'member.info.get',

    REQ_ORDER_PAY: 'member.order.pay',
};

export default constant;
